import React, { useState } from "react";
import { countries } from "./data";
import "../assests/CSS/Thhiyapediacomp2.css";

const Thhiyapediacomp2 = () => {
  const [selectedRegion, setSelectedRegion] = useState("All");

  const filters = ["All", "USA", "India", "Australia", "Europe", "Asia", "Canada", "South America"];

  const filteredCountries =
    selectedRegion === "All"
      ? countries
      : countries.filter((c) => c.region === selectedRegion);

  return (
    <div className="tp-container">
      <div className="tp-header">
        <h2 className="tp-heading">Explore top</h2>
        <div className="tp-filters">
          {filters.map((region) => (
            <button
              key={region}
              className={`tp-btn ${selectedRegion === region ? "active" : ""}`}
              onClick={() => setSelectedRegion(region)}
            >
              {region}
            </button>
          ))}
        </div>
      </div>

      <div className="tp-grid">
        {filteredCountries.map((country) => (
          <div key={country.id} className="tp-card">
            <div className="tp-flag-container">
              <img src={country.flag} alt={country.name} className="tp-flag" />
            </div>
            <div className="tp-card-bottom">
              <div className="tp-row">
                <span className="tp-label">Currency:</span>
                <span className="tp-value">{country.currency}</span>
              </div>
              <div className="tp-row">
                <span className="tp-label">Employer Contribution:</span>
                <span className="tp-value">{country.contribution}</span>
              </div>
              <div className="tp-row">
                <span className="tp-label">Minimum Wage:</span>
                <span className="tp-value">{country.wage}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Thhiyapediacomp2;
